import React, { useState, memo } from "react";
import IconButton from "@mui/material/IconButton";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import moment from "moment-jalaali";
import ExcelJS from "exceljs";
import Api from "../../utils/api";
import { Loading } from "../../components";
import { useSelector } from "react-redux";
import {Tooltip} from "@mui/material";

const FinanceExcelDownload = ({ object }) => {
    const AppState = useSelector((state) => state);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {

            const params = { ...object, excel_export: 1 };
            const response = await new Api().get("/finance", params);
            const items = Array.isArray(response) ? response : [];

            if (items.length === 0) {
                setLoading(false);
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Finance");

            worksheet.columns = [
                { header: "شناسه", key: "id", width: 15 },
                { header: "کاربر", key: "user", width: 25 },
                { header: "بدهکار", key: "debtor", width: 20 },
                { header: "بستانکار", key: "creditor", width: 20 },
                { header: "نوع", key: "type", width: 20 },
                { header: "تاریخ ثبت", key: "created_at", width: 25 },
            ];

            items.forEach((entity) => {
                worksheet.addRow({
                    id: entity.id,
                    user: entity.user ? `${entity.user.name} ${entity.user.family}` : '-',
                    debtor: entity.debtor ?? '-',
                    creditor: entity.creditor ?? '-',
                    type: AppState.finance.type?.[entity.type] || '-',
                    created_at: moment(entity.created_at)
                        .locale('fa')
                        .format('jYYYY/jMM/jDD HH:mm:ss'),
                });
            });

            worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true, size: 15 };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFCCEEFF" } };
                cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
            });

            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                if (rowNumber > 1) {
                    row.eachCell((cell) => {
                        cell.font = { size: 13 };
                        cell.alignment = { horizontal: "center", vertical: "middle" };
                    });
                }
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `finance_${moment().unix()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error exporting finance data:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Tooltip title="خروجی اکسل">
                <IconButton onClick={fetchData} disabled={loading}>
                    <ImportExportIcon />
                </IconButton>
            </Tooltip>
            {loading && <Loading />}
        </>
    );
};

export default memo(FinanceExcelDownload);